module.exports = __webpack_public_path__ + "media/images/e-bilet/about/traintimetable-70d12c1c0b8835cf11d7424105ef0d8c.svg";